import { atom } from 'recoil';
import { StaticConfig } from '../models/IStaticConfig';
import { IParticipantDetail } from '../models/IParticipantDetail';

export const showHeaderState = atom({
  key: 'showHeaderState',
  default: true,
});

export const screenShareState = atom({
  key: 'screenShareState',
  default: false,
});

export const fileShareInfosState = atom<
  { fileName: string; showLoader: boolean }[]
>({
  key: 'fileShareInfosState',
  default: [],
});

export const staticConfigAtom = atom<StaticConfig | null>({
  key: 'staticConfigAtom',
  default: null,
});

export const showForceUpdateDialogState = atom({
  key: 'showForceUpdateDialogState',
  default: false,
});

export const oneToOneChatParticipantIdState = atom<{participantId: string, isParticipantSelected: boolean}>({
  key: 'oneToOneChatParticipantIdState',
  default: {participantId: '', isParticipantSelected: false}
});

export const isNewParticipantJoinedState = atom<boolean>({
  key: 'isNewParticipantJoinedState',
  default: false
})

export const isRDPMinizedState = atom<boolean>({
  key: 'isRDPMinizedState',
  default: false
});

export const isMeetingTerminated = atom<boolean>({
  key: 'isMeetingTerminated',
  default: false
});

export const isMeeetingDisconnected = atom<boolean>({
  key: 'isMeeetingDisconnected',
  default: false
});

export const participantDetailState = atom<IParticipantDetail | null>({
  key: 'setParticipantDetails',
  default: null,
});